import { styled, Button, Text, Stack } from '@withjoy/joykit';

export const FullWidthButton = styled(Button)`
  width: 100%;
  margin-top: 2rem;
`;

export const EnhancedStack = styled(Stack)`
  width: 22rem;
  align-items: center;
  margin-bottom: 10rem;
`;

export const InputStack = styled(Stack)`
  width: 100%;
`;

export const CenterText = styled(Text)`
  text-align: center;
`;

export const ErrorText = styled(Text)`
  margin-top: 8px;
`;
